// import React, { useState } from "react";
// import ProductCard from "../components/products/ProductCard";
// import { products } from "../data/products";
// import "./ProductsPage.css";
// import { useParams, useRoutes } from "react-router-dom";

// const ProductsPage = ({ onProductClick }) => {
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedGender, setSelectedGender] = useState("all");
//   const [selectedAge, setSelectedAge] = useState("all");
//   const [selectedColor, setSelectedColor] = useState("all");
//   const [selectedSize, setSelectedSize] = useState("all");
//   const [showCategoryFilter, setShowCategoryFilter] = useState(false);
//   const [showAgeFilter, setShowAgeFilter] = useState(false);
//   const [showColorFilter, setShowColorFilter] = useState(false);
//   const [showSizeFilter, setShowSizeFilter] = useState(false);
//   const { name } = useParams();
//   console.log(name, "name here");
//   // Filter products
//   let filteredProducts = products;

//   if (selectedGender !== "all") {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.gender === selectedGender || p.gender === "unisex"
//     );
//   }

//   if (selectedCategory !== "all") {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.category === selectedCategory
//     );
//   }

//   if (selectedAge !== "all") {
//     filteredProducts = filteredProducts.filter((p) => p.age === selectedAge);
//   }

//   if (selectedColor !== "all") {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.color === selectedColor
//     );
//   }

//   if (selectedSize !== "all") {
//     filteredProducts = filteredProducts.filter((p) =>
//       p.sizes.includes(selectedSize)
//     );
//   }

//   const categories = [
//     "all",
//     "dresses",
//     "tops",
//     "bottoms",
//     "jackets",
//     "co-ord sets",
//     "hoodies",
//     "sweaters",
//     "rompers",
//     "onesies",
//   ];
//   const ages = [
//     "all",
//     "0-2 Years",
//     "2-4 Years",
//     "4-6 Years",
//     "6-8 Years",
//     "8-10 Years",
//     "10-12 Years",
//     "12-14 Years",
//   ];
//   const colors = [
//     "all",
//     "pink",
//     "blue",
//     "red",
//     "purple",
//     "green",
//     "black",
//     "white",
//     "yellow",
//     "navy",
//     "multicolor",
//     "gray",
//     "cream",
//     "brown",
//   ];
//   const sizes = [
//     "all",
//     "0-3M",
//     "3-6M",
//     "6-12M",
//     "6M",
//     "12M",
//     "18M",
//     "24M",
//     "2Y",
//     "3Y",
//     "4Y",
//     "8Y",
//     "10Y",
//     "12Y",
//     "14Y",
//   ];

//   const clearAllFilters = () => {
//     setSelectedGender("all");
//     setSelectedCategory("all");
//     setSelectedAge("all");
//     setSelectedColor("all");
//     setSelectedSize("all");
//   };

//   const activeFiltersCount = [
//     selectedGender,
//     selectedCategory,
//     selectedAge,
//     selectedColor,
//     selectedSize,
//   ].filter((f) => f !== "all").length;

//   return (
//     <div className="products-page-clean">
//       <div className="products-header-clean">
//         <h1 className="products-page-title">Shop All Products</h1>
//         <p className="products-page-subtitle">
//           Discover our complete collection of premium kids wear
//         </p>
//       </div>

//       <div className="products-content-clean">
//         <div className="container">
//           {/* Filters */}
//           <div className="filters-section">
//             <div className="filters-header">
//               <div className="filters-title">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
//                 </svg>
//                 <span>Filters</span>
//                 {activeFiltersCount > 0 && (
//                   <span className="active-count">({activeFiltersCount})</span>
//                 )}
//               </div>
//               {activeFiltersCount > 0 && (
//                 <button className="clear-all-btn" onClick={clearAllFilters}>
//                   Clear All
//                 </button>
//               )}
//             </div>

//             <div className="filters-grid">
//               {/* Gender Filter */}
//               <div className="filter-group-new">
//                 <div className="filter-buttons-new">
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "all" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("all")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//                       <circle cx="12" cy="7" r="4" />
//                     </svg>
//                     All
//                   </button>
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "girls" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("girls")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="8" r="7" />
//                       <polyline points="12 15 12 21" />
//                       <polyline points="8 19 12 21 16 19" />
//                     </svg>
//                     Girls
//                   </button>
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "boys" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("boys")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="10" cy="14" r="7" />
//                       <line x1="21" y1="3" x2="15" y2="9" />
//                       <line x1="15" y1="3" x2="21" y2="3" />
//                       <line x1="21" y1="3" x2="21" y2="9" />
//                     </svg>
//                     Boys
//                   </button>
//                 </div>
//               </div>

//               {/* Category Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showCategoryFilter ? "active" : ""
//                   } ${selectedCategory !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowCategoryFilter(!showCategoryFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <rect x="3" y="3" width="7" height="7" />
//                       <rect x="14" y="3" width="7" height="7" />
//                       <rect x="14" y="14" width="7" height="7" />
//                       <rect x="3" y="14" width="7" height="7" />
//                     </svg>
//                     <span>
//                       {selectedCategory === "all"
//                         ? "Category"
//                         : selectedCategory}
//                     </span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showCategoryFilter && (
//                   <div className="filter-dropdown-menu">
//                     {categories.map((cat) => (
//                       <button
//                         key={cat}
//                         className={`filter-dropdown-item ${
//                           selectedCategory === cat ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedCategory(cat);
//                           setShowCategoryFilter(false);
//                         }}
//                       >
//                         {cat === "all"
//                           ? "All Categories"
//                           : cat.charAt(0).toUpperCase() + cat.slice(1)}
//                         {selectedCategory === cat && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Age Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showAgeFilter ? "active" : ""
//                   } ${selectedAge !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowAgeFilter(!showAgeFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="12" r="10" />
//                       <polyline points="12 6 12 12 16 14" />
//                     </svg>
//                     <span>{selectedAge === "all" ? "Age" : selectedAge}</span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showAgeFilter && (
//                   <div className="filter-dropdown-menu">
//                     {ages.map((age) => (
//                       <button
//                         key={age}
//                         className={`filter-dropdown-item ${
//                           selectedAge === age ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedAge(age);
//                           setShowAgeFilter(false);
//                         }}
//                       >
//                         {age === "all" ? "All Ages" : age}
//                         {selectedAge === age && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Color Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showColorFilter ? "active" : ""
//                   } ${selectedColor !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowColorFilter(!showColorFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="12" r="10" />
//                       <path d="M12 2a10 10 0 0 0 0 20c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
//                     </svg>
//                     <span>
//                       {selectedColor === "all" ? "Color" : selectedColor}
//                     </span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showColorFilter && (
//                   <div className="filter-dropdown-menu">
//                     {colors.map((color) => (
//                       <button
//                         key={color}
//                         className={`filter-dropdown-item ${
//                           selectedColor === color ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedColor(color);
//                           setShowColorFilter(false);
//                         }}
//                       >
//                         {color === "all"
//                           ? "All Colors"
//                           : color.charAt(0).toUpperCase() + color.slice(1)}
//                         {selectedColor === color && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Size Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showSizeFilter ? "active" : ""
//                   } ${selectedSize !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowSizeFilter(!showSizeFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <polyline points="21 8 21 21 3 21 3 8" />
//                       <rect x="1" y="3" width="22" height="5" />
//                       <line x1="10" y1="12" x2="14" y2="12" />
//                     </svg>
//                     <span>
//                       {selectedSize === "all" ? "Size" : selectedSize}
//                     </span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showSizeFilter && (
//                   <div className="filter-dropdown-menu">
//                     {sizes.map((size) => (
//                       <button
//                         key={size}
//                         className={`filter-dropdown-item ${
//                           selectedSize === size ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedSize(size);
//                           setShowSizeFilter(false);
//                         }}
//                       >
//                         {size === "all" ? "All Sizes" : size}
//                         {selectedSize === size && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Active Filters Tags */}
//             {activeFiltersCount > 0 && (
//               <div className="active-filters-tags">
//                 {selectedGender !== "all" && (
//                   <span className="filter-tag">
//                     {selectedGender}
//                     <button onClick={() => setSelectedGender("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedCategory !== "all" && (
//                   <span className="filter-tag">
//                     {selectedCategory}
//                     <button onClick={() => setSelectedCategory("all")}>
//                       ×
//                     </button>
//                   </span>
//                 )}
//                 {selectedAge !== "all" && (
//                   <span className="filter-tag">
//                     {selectedAge}
//                     <button onClick={() => setSelectedAge("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedColor !== "all" && (
//                   <span className="filter-tag">
//                     {selectedColor}
//                     <button onClick={() => setSelectedColor("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedSize !== "all" && (
//                   <span className="filter-tag">
//                     {selectedSize}
//                     <button onClick={() => setSelectedSize("all")}>×</button>
//                   </span>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Results Count */}
//           <div className="results-info">
//             <p>
//               {filteredProducts.length}{" "}
//               {filteredProducts.length === 1 ? "Product" : "Products"} Found
//             </p>
//           </div>

//           {/* Products Grid */}
//           <div className="products-grid-clean">
//             {filteredProducts.map((product) => (
//               <ProductCard
//                 key={product.id}
//                 product={product}
//                 onQuickView={onProductClick}
//               />
//             ))}
//           </div>

//           {filteredProducts.length === 0 && (
//             <div className="no-products-found">
//               <svg
//                 width="80"
//                 height="80"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="1"
//               >
//                 <circle cx="11" cy="11" r="8" />
//                 <path d="m21 21-4.35-4.35" />
//               </svg>
//               <h3>No products found</h3>
//               <p>Try adjusting your filters to find what you're looking for</p>
//               <button className="reset-filters-btn" onClick={clearAllFilters}>
//                 Reset All Filters
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductsPage;

// import React, { useState, useEffect } from "react";
// import ProductCard from "../components/products/ProductCard";
// import "./ProductsPage.css";
// import { useParams } from "react-router-dom";
// import productService from "../services/productService";
// import categoryService from "../services/categoryService";

// const ProductsPage = ({ onProductClick }) => {
//   const [products, setProducts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedGender, setSelectedGender] = useState("all");
//   const [selectedAge, setSelectedAge] = useState("all");
//   const [selectedColor, setSelectedColor] = useState("all");
//   const [selectedSize, setSelectedSize] = useState("all");
//   const [showCategoryFilter, setShowCategoryFilter] = useState(false);
//   const [showAgeFilter, setShowAgeFilter] = useState(false);
//   const [showColorFilter, setShowColorFilter] = useState(false);
//   const [showSizeFilter, setShowSizeFilter] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [showQuickView, setShowQuickView] = useState(false);
//   const { name } = useParams();

//   // Fetch products and categories on mount
//   useEffect(() => {
//     fetchCategories();
//     fetchProducts();
//   }, []);

//   // Fetch products when category param changes
//   useEffect(() => {
//     if (name) {
//       fetchProductsByCategory(name);
//     } else {
//       fetchProducts();
//     }
//   }, [name]);

//   const fetchCategories = async () => {
//     try {
//       const response = await categoryService.getCategoryTree();
//       if (response?.success && response?.data) {
//         // Flatten category tree to get all categories
//         const allCategories = flattenCategories(response.data);
//         setCategories(allCategories);
//       }
//     } catch (error) {
//       console.error("Error fetching categories:", error);
//     }
//   };

//   const flattenCategories = (categoriesTree) => {
//     let flat = [];
//     categoriesTree.forEach((cat) => {
//       flat.push({ id: cat._id, name: cat.name, slug: cat.slug });
//       if (cat.children && cat.children.length > 0) {
//         flat = [...flat, ...flattenCategories(cat.children)];
//       }
//     });
//     return flat;
//   };

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await productService.getProducts({
//         page: 1,
//         limit: 100,
//       });

//       if (response?.success && response?.data) {
//         setProducts(response?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching products:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchProductsByCategory = async (categorySlug) => {
//     try {
//       setLoading(true);

//       // Find category by slug
//       const category = categories.find(
//         (cat) =>
//           cat.slug === categorySlug ||
//           cat.name.toLowerCase().replace(/\s+/g, "-") === categorySlug
//       );

//       if (category) {
//         const response = await productService.getProducts({
//           category: category.id,
//           page: 1,
//           limit: 100,
//         });

//         if (response?.success && response?.data) {
//           setProducts(response.data);
//           setSelectedCategory(category.id);
//         }
//       } else {
//         // If category not found, fetch all products
//         fetchProducts();
//       }
//     } catch (error) {
//       console.error("Error fetching products by category:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Client-side filtering for additional filters
//   let filteredProducts = products;

//   if (selectedGender !== "all") {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.gender === selectedGender || p.gender === "unisex"
//     );
//   }

//   if (selectedCategory !== "all" && !name) {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.category?._id === selectedCategory
//     );
//   }

//   if (selectedAge !== "all") {
//     filteredProducts = filteredProducts.filter((p) => p.age === selectedAge);
//   }

//   if (selectedColor !== "all") {
//     filteredProducts = filteredProducts.filter(
//       (p) => p.color === selectedColor
//     );
//   }

//   if (selectedSize !== "all") {
//     filteredProducts = filteredProducts.filter((p) =>
//       p.sizes?.includes(selectedSize)
//     );
//   }

//   const ages = [
//     "all",
//     "0-2 Years",
//     "2-4 Years",
//     "4-6 Years",
//     "6-8 Years",
//     "8-10 Years",
//     "10-12 Years",
//     "12-14 Years",
//   ];

//   const colors = [
//     "all",
//     "pink",
//     "blue",
//     "red",
//     "purple",
//     "green",
//     "black",
//     "white",
//     "yellow",
//     "navy",
//     "multicolor",
//     "gray",
//     "cream",
//     "brown",
//   ];

//   const sizes = [
//     "all",
//     "0-3M",
//     "3-6M",
//     "6-12M",
//     "6M",
//     "12M",
//     "18M",
//     "24M",
//     "2Y",
//     "3Y",
//     "4Y",
//     "8Y",
//     "10Y",
//     "12Y",
//     "14Y",
//   ];

//   const clearAllFilters = () => {
//     setSelectedGender("all");
//     setSelectedCategory("all");
//     setSelectedAge("all");
//     setSelectedColor("all");
//     setSelectedSize("all");
//   };

//   const activeFiltersCount = [
//     selectedGender,
//     selectedCategory !== "all" && !name ? selectedCategory : null,
//     selectedAge,
//     selectedColor,
//     selectedSize,
//   ].filter((f) => f !== "all" && f !== null).length;

//   // Get current category name for display
//   const getCurrentCategoryName = () => {
//     if (name) {
//       const category = categories.find(
//         (cat) =>
//           cat.slug === name ||
//           cat.name.toLowerCase().replace(/\s+/g, "-") === name
//       );
//       return category
//         ? category.name
//         : name.charAt(0).toUpperCase() + name.slice(1);
//     }
//     return "All Products";
//   };

//   return (
//     <div className="products-page-clean">
//       <div className="products-header-clean">
//         <h1 className="products-page-title">
//           {name ? getCurrentCategoryName() : "Shop All Products"}
//         </h1>
//         <p className="products-page-subtitle">
//           {name
//             ? `Explore our collection of ${getCurrentCategoryName().toLowerCase()}`
//             : "Discover our complete collection of premium kids wear"}
//         </p>
//       </div>

//       <div className="products-content-clean">
//         <div className="container">
//           {/* Filters */}
//           <div className="filters-section">
//             <div className="filters-header">
//               <div className="filters-title">
//                 <svg
//                   width="20"
//                   height="20"
//                   viewBox="0 0 24 24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                 >
//                   <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
//                 </svg>
//                 <span>Filters</span>
//                 {activeFiltersCount > 0 && (
//                   <span className="active-count">({activeFiltersCount})</span>
//                 )}
//               </div>
//               {activeFiltersCount > 0 && (
//                 <button className="clear-all-btn" onClick={clearAllFilters}>
//                   Clear All
//                 </button>
//               )}
//             </div>

//             <div className="filters-grid">
//               {/* Gender Filter */}
//               <div className="filter-group-new">
//                 <div className="filter-buttons-new">
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "all" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("all")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
//                       <circle cx="12" cy="7" r="4" />
//                     </svg>
//                     All
//                   </button>
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "girls" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("girls")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="8" r="7" />
//                       <polyline points="12 15 12 21" />
//                       <polyline points="8 19 12 21 16 19" />
//                     </svg>
//                     Girls
//                   </button>
//                   <button
//                     className={`filter-btn-new ${
//                       selectedGender === "boys" ? "active" : ""
//                     }`}
//                     onClick={() => setSelectedGender("boys")}
//                   >
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="10" cy="14" r="7" />
//                       <line x1="21" y1="3" x2="15" y2="9" />
//                       <line x1="15" y1="3" x2="21" y2="3" />
//                       <line x1="21" y1="3" x2="21" y2="9" />
//                     </svg>
//                     Boys
//                   </button>
//                 </div>
//               </div>

//               {/* Category Filter - Only show if not filtering by URL param */}
//               {!name && (
//                 <div className="filter-dropdown-wrapper">
//                   <button
//                     className={`filter-dropdown-btn ${
//                       showCategoryFilter ? "active" : ""
//                     } ${selectedCategory !== "all" ? "has-value" : ""}`}
//                     onClick={() => setShowCategoryFilter(!showCategoryFilter)}
//                   >
//                     <div className="filter-dropdown-label">
//                       <svg
//                         width="16"
//                         height="16"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="currentColor"
//                         strokeWidth="2"
//                       >
//                         <rect x="3" y="3" width="7" height="7" />
//                         <rect x="14" y="3" width="7" height="7" />
//                         <rect x="14" y="14" width="7" height="7" />
//                         <rect x="3" y="14" width="7" height="7" />
//                       </svg>
//                       <span>
//                         {selectedCategory === "all"
//                           ? "Category"
//                           : categories.find((c) => c.id === selectedCategory)
//                               ?.name || "Category"}
//                       </span>
//                     </div>
//                     <svg
//                       className="dropdown-arrow"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <polyline points="6 9 12 15 18 9" />
//                     </svg>
//                   </button>
//                   {showCategoryFilter && (
//                     <div className="filter-dropdown-menu">
//                       <button
//                         className={`filter-dropdown-item ${
//                           selectedCategory === "all" ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedCategory("all");
//                           setShowCategoryFilter(false);
//                           fetchProducts();
//                         }}
//                       >
//                         All Categories
//                         {selectedCategory === "all" && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                       {categories.map((cat) => (
//                         <button
//                           key={cat.id}
//                           className={`filter-dropdown-item ${
//                             selectedCategory === cat.id ? "active" : ""
//                           }`}
//                           onClick={() => {
//                             setSelectedCategory(cat.id);
//                             setShowCategoryFilter(false);
//                           }}
//                         >
//                           {cat.name}
//                           {selectedCategory === cat.id && (
//                             <svg
//                               width="14"
//                               height="14"
//                               viewBox="0 0 24 24"
//                               fill="none"
//                               stroke="currentColor"
//                               strokeWidth="3"
//                             >
//                               <polyline points="20 6 9 17 4 12" />
//                             </svg>
//                           )}
//                         </button>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Age Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showAgeFilter ? "active" : ""
//                   } ${selectedAge !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowAgeFilter(!showAgeFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="12" r="10" />
//                       <polyline points="12 6 12 12 16 14" />
//                     </svg>
//                     <span>{selectedAge === "all" ? "Age" : selectedAge}</span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showAgeFilter && (
//                   <div className="filter-dropdown-menu">
//                     {ages.map((age) => (
//                       <button
//                         key={age}
//                         className={`filter-dropdown-item ${
//                           selectedAge === age ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedAge(age);
//                           setShowAgeFilter(false);
//                         }}
//                       >
//                         {age === "all" ? "All Ages" : age}
//                         {selectedAge === age && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Color Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showColorFilter ? "active" : ""
//                   } ${selectedColor !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowColorFilter(!showColorFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <circle cx="12" cy="12" r="10" />
//                       <path d="M12 2a10 10 0 0 0 0 20c5.52 0 10-4.48 10-10S17.52 2 12 2z" />
//                     </svg>
//                     <span>
//                       {selectedColor === "all" ? "Color" : selectedColor}
//                     </span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showColorFilter && (
//                   <div className="filter-dropdown-menu">
//                     {colors.map((color) => (
//                       <button
//                         key={color}
//                         className={`filter-dropdown-item ${
//                           selectedColor === color ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedColor(color);
//                           setShowColorFilter(false);
//                         }}
//                       >
//                         {color === "all"
//                           ? "All Colors"
//                           : color.charAt(0).toUpperCase() + color.slice(1)}
//                         {selectedColor === color && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               {/* Size Filter */}
//               <div className="filter-dropdown-wrapper">
//                 <button
//                   className={`filter-dropdown-btn ${
//                     showSizeFilter ? "active" : ""
//                   } ${selectedSize !== "all" ? "has-value" : ""}`}
//                   onClick={() => setShowSizeFilter(!showSizeFilter)}
//                 >
//                   <div className="filter-dropdown-label">
//                     <svg
//                       width="16"
//                       height="16"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     >
//                       <polyline points="21 8 21 21 3 21 3 8" />
//                       <rect x="1" y="3" width="22" height="5" />
//                       <line x1="10" y1="12" x2="14" y2="12" />
//                     </svg>
//                     <span>
//                       {selectedSize === "all" ? "Size" : selectedSize}
//                     </span>
//                   </div>
//                   <svg
//                     className="dropdown-arrow"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <polyline points="6 9 12 15 18 9" />
//                   </svg>
//                 </button>
//                 {showSizeFilter && (
//                   <div className="filter-dropdown-menu">
//                     {sizes.map((size) => (
//                       <button
//                         key={size}
//                         className={`filter-dropdown-item ${
//                           selectedSize === size ? "active" : ""
//                         }`}
//                         onClick={() => {
//                           setSelectedSize(size);
//                           setShowSizeFilter(false);
//                         }}
//                       >
//                         {size === "all" ? "All Sizes" : size}
//                         {selectedSize === size && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="currentColor"
//                             strokeWidth="3"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </button>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Active Filters Tags */}
//             {activeFiltersCount > 0 && (
//               <div className="active-filters-tags">
//                 {selectedGender !== "all" && (
//                   <span className="filter-tag">
//                     {selectedGender}
//                     <button onClick={() => setSelectedGender("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedCategory !== "all" && !name && (
//                   <span className="filter-tag">
//                     {categories.find((c) => c.id === selectedCategory)?.name}
//                     <button onClick={() => setSelectedCategory("all")}>
//                       ×
//                     </button>
//                   </span>
//                 )}
//                 {selectedAge !== "all" && (
//                   <span className="filter-tag">
//                     {selectedAge}
//                     <button onClick={() => setSelectedAge("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedColor !== "all" && (
//                   <span className="filter-tag">
//                     {selectedColor}
//                     <button onClick={() => setSelectedColor("all")}>×</button>
//                   </span>
//                 )}
//                 {selectedSize !== "all" && (
//                   <span className="filter-tag">
//                     {selectedSize}
//                     <button onClick={() => setSelectedSize("all")}>×</button>
//                   </span>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Results Count */}
//           <div className="results-info">
//             <p>
//               {filteredProducts.length}{" "}
//               {filteredProducts.length === 1 ? "Product" : "Products"} Found
//             </p>
//           </div>

//           {/* Loading State */}
//           {loading ? (
//             <div
//               className="loading-state"
//               style={{
//                 textAlign: "center",
//                 padding: "60px 20px",
//                 color: "#999",
//               }}
//             >
//               <div
//                 className="spinner"
//                 style={{
//                   border: "3px solid #f3f3f3",
//                   borderTop: "3px solid #c77a5c",
//                   borderRadius: "50%",
//                   width: "50px",
//                   height: "50px",
//                   animation: "spin 1s linear infinite",
//                   margin: "0 auto 20px",
//                 }}
//               ></div>
//               <p>Loading products...</p>
//             </div>
//           ) : (
//             <>
//               {/* Products Grid */}
//               <div className="products-grid-clean">
//                 {filteredProducts?.map((product) => (
//                   <ProductCard
//                     key={product._id}
//                     product={product}
//                     onQuickView={onProductClick}
//                   />
//                 ))}
//               </div>

//               {filteredProducts.length === 0 && (
//                 <div className="no-products-found">
//                   <svg
//                     width="80"
//                     height="80"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="1"
//                   >
//                     <circle cx="11" cy="11" r="8" />
//                     <path d="m21 21-4.35-4.35" />
//                   </svg>
//                   <h3>No products found</h3>
//                   <p>
//                     Try adjusting your filters to find what you're looking for
//                   </p>
//                   <button
//                     className="reset-filters-btn"
//                     onClick={clearAllFilters}
//                   >
//                     Reset All Filters
//                   </button>
//                 </div>
//               )}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductsPage;
import React, { useState, useEffect } from "react";
import ProductCardNew from "../components/card/ProductCardNew";
import "./ProductsPage.css";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import productService from "../services/productService";
import categoryService from "../services/categoryService";
import settingService from "../services/settingService";

const ProductsPage = ({ onProductClick }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGender, setSelectedGender] = useState("all");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedSize, setSelectedSize] = useState("all");
  const [showGenderModal, setShowGenderModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [genderCategories, setGenderCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const { name } = useParams();
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  console.log(state, name, "state");
  // Fetch products, categories, and sizes on mount
  useEffect(() => {
    fetchCategories();
    fetchSizes();
  }, []);

  // Filter categories when gender changes
  useEffect(() => {
    if (selectedGender === "all") {
      setFilteredCategories(categories);
    } else {
      // Filter to show only categories that are children of selected gender
      const filtered = categories.filter(
        (cat) => cat.parent && cat.parent.id === selectedGender
      );
      setFilteredCategories(filtered);
    }
  }, [selectedGender, categories]);

  // Fetch products when params change
  useEffect(() => {
    const filter = searchParams.get("filter");
    const search = searchParams.get("search");

    if (search) {
      fetchProductsBySearch(search);
    } else if (name) {
      fetchProductsByCategory({
        name,
        id: state?.product?.id,
        parent: state?.parent ? true : false,
        categoryList: state?.categoryList ? true : false,
        shopByAge: state?.data?.slug === "shop-by-age" ? true : false,
        filterBySize: state?.filterBySize,
        sizes: state?.filterBySize ? state.sizes : [],
      });
    } else if (filter) {
      fetchProductsByFilter(filter);
    } else {
      fetchProducts();
    }
  }, [name, searchParams]);

  const fetchCategories = async () => {
    try {
      const response = await categoryService.getCategoryTree();
      if (response?.success && response?.data) {
        setCategoryTree(response.data);
        const allCategories = flattenCategoriesWithParent(response.data);
        setCategories(allCategories);

        // Extract top-level gender categories (categories with children)
        const genders = response.data
          .filter((cat) => cat.children && cat.children.length > 0)
          .map((cat) => ({ id: cat._id, name: cat.name, slug: cat.slug }))
          .filter((y) => y.name === "Boys" || y.name === "Girls");

        setGenderCategories(genders);

        // Initially show all categories
        setFilteredCategories(allCategories);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSizes = async () => {
    try {
      const response = await settingService.getSettings();

      if (response?._id && response?.sizes) {
        const activeSizes = response.sizes.filter((size) => size.isActive);
        setSizes(activeSizes);
      }
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  const flattenCategoriesWithParent = (categoriesTree, parent = null) => {
    let flat = [];
    categoriesTree.forEach((cat) => {
      flat.push({
        id: cat._id,
        name: cat.name,
        slug: cat.slug,
        parent: parent,
        rootParent: parent?.rootParent || parent,
      });
      if (cat.children && cat.children.length > 0) {
        flat = [
          ...flat,
          ...flattenCategoriesWithParent(cat.children, {
            id: cat._id,
            name: cat.name,
            parent: parent,
            rootParent: parent?.rootParent ||
              parent || { id: cat._id, name: cat.name },
          }),
        ];
      }
    });
    return flat;
  };

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await productService.getProducts({
        page: 1,
        limit: 100,
        status: "Active",
      });

      if (response?.success && response?.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductsByCategory = async ({
    name: categorySlug,
    id,
    parent,
    categoryList,
    shopByAge,
    filterBySize,
    sizes,
  }) => {
    try {
      setLoading(true);

      const category = categories.find(
        (cat) =>
          cat.slug === categorySlug ||
          cat.name.toLowerCase().replace(/\s+/g, "-") === categorySlug
      );
      if (filterBySize) {
        const response = await productService.getProducts({
          category: id,
          page: 1,
          limit: 100,
          status: "Active",
          parent: parent,
          filterBySize,
          sizes,
        });

        if (response?.success && response?.data) {
          setProducts(response.data);
          setSelectedCategory(id);
        }
      } else if (shopByAge && name) {
        const response = await productService.getProducts({
          category: id,
          page: 1,
          limit: 100,
          status: "Active",
          parent: parent,
          shopByAge,
          name,
        });

        if (response?.success && response?.data) {
          setProducts(response.data);
          setSelectedCategory(id);
        }
      } else if (categoryList && name) {
        const response = await productService.getProducts({
          category: id,
          page: 1,
          limit: 100,
          status: "Active",
          parent: parent,
          categoryList,
          name,
        });

        if (response?.success && response?.data) {
          setProducts(response.data);
          setSelectedCategory(id);
        }
      } else if (id) {
        const response = await productService.getProducts({
          category: id,
          page: 1,
          limit: 100,
          status: "Active",
          parent: parent,
        });

        if (response?.success && response?.data) {
          setProducts(response.data);
          setSelectedCategory(id);
        }
      } else if (category) {
        const response = await productService.getProducts({
          category: category.id,
          page: 1,
          limit: 100,
          status: "Active",
        });

        if (response?.success && response?.data) {
          setProducts(response.data);
          setSelectedCategory(category.id);
        }
      } else {
        fetchProducts();
      }
    } catch (error) {
      console.error("Error fetching products by category:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductsByFilter = async (filter) => {
    try {
      setLoading(true);
      let queryParams = {
        page: 1,
        limit: 100,
        status: "Active",
      };

      // Map filter to API parameters
      if (filter === "new") {
        queryParams.isNew = "true";
      } else if (filter === "hotdeal") {
        queryParams.isHotDeal = "true";
      } else if (filter === "featured") {
        queryParams.isFeatured = "true";
      }

      const response = await productService.getProducts(queryParams);

      if (response?.success && response?.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching filtered products:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProductsBySearch = async (searchQuery) => {
    try {
      setLoading(true);
      const response = await productService.searchProducts(searchQuery);

      if (response?.success && response?.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error searching products:", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // Client-side filtering
  let filteredProducts = products;

  if (selectedGender !== "all") {
    // Filter products whose category belongs to selected gender
    const genderCategoryIds = categories
      .filter((cat) => cat.parent && cat.parent.id === selectedGender)
      .map((cat) => cat.id);

    filteredProducts = filteredProducts.filter((p) => {
      // Check if product's main category or any of its categories belong to selected gender
      const mainCategoryMatch = genderCategoryIds.includes(p.category?._id);
      const categoriesMatch = p.categories?.some((cat) =>
        genderCategoryIds.includes(cat._id)
      );
      return mainCategoryMatch || categoriesMatch;
    });
  }

  if (selectedCategory !== "all" && !name) {
    filteredProducts = filteredProducts.filter(
      (p) => p.category?._id === selectedCategory
    );
  }

  if (selectedSize !== "all") {
    filteredProducts = filteredProducts.filter((p) =>
      p.sizes?.includes(selectedSize)
    );
  }

  const clearAllFilters = () => {
    setSelectedGender("all");
    setSelectedCategory("all");
    setSelectedSize("all");
  };

  const activeFiltersCount = [
    selectedGender !== "all" ? selectedGender : null,
    selectedCategory !== "all" && !name ? selectedCategory : null,
    selectedSize !== "all" ? selectedSize : null,
  ].filter((f) => f !== "all" && f !== null).length;

  const getCategoryBreadcrumb = () => {
    if (!name) return null;

    const category = categories.find(
      (cat) =>
        cat.slug === name ||
        cat.name.toLowerCase().replace(/\s+/g, "-") === name
    );

    if (!category) return null;

    // If has root parent (grandparent), show: RootParent > Current
    // Skip the middle parent level
    if (category.rootParent && category.rootParent.id !== category.id) {
      return {
        root: category.rootParent.name,
        current: category.name,
      };
    }
    // If has direct parent, show: Parent > Current
    else if (category.parent && category.parent.id !== category.id) {
      return {
        root: category.parent.name,
        current: category.name,
      };
    }

    // No parent, just show current
    return {
      root: null,
      current: category.name,
    };
  };

  const getCurrentCategoryName = () => {
    const filter = searchParams.get("filter");
    const search = searchParams.get("search");

    if (search) return `Search Results for "${search}"`;
    if (filter === "new") return "New Arrivals";
    if (filter === "hotdeal") return "Hot Deals";
    if (filter === "featured") return "Featured Products";

    const breadcrumb = getCategoryBreadcrumb();
    if (breadcrumb) {
      return breadcrumb.root
        ? `${breadcrumb.root} > ${breadcrumb.current}`
        : breadcrumb.current;
    }

    return "All Products";
  };

  const getSubtitle = () => {
    const filter = searchParams.get("filter");
    const search = searchParams.get("search");

    if (search)
      return `Found ${products.length} product${
        products.length !== 1 ? "s" : ""
      } matching your search`;
    if (filter === "new") return "Discover our latest collection";
    if (filter === "hotdeal")
      return "Best deals and offers on premium kids wear";
    if (filter === "featured") return "Our handpicked featured collection";

    if (name) {
      return `Explore our collection of ${getCurrentCategoryName().toLowerCase()}`;
    }
    return "Discover our complete collection of premium kids wear";
  };

  return (
    <div className="products-page-clean">
      {/* <div className="products-header-clean">
        <h1 className="products-page-title">{getCurrentCategoryName()}</h1>
        <p className="products-page-subtitle">{getSubtitle()}</p>
      </div> */}

      <div className="products-content-clean">
        <div className="container">
          {/* Filters - Mobile Icon Toggle */}
          <div className="filters-section">
            <div className="filters-header">
              <div className="filters-title">
                <button
                  className="filter-icon-toggle"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                  </svg>
                  <span>Filters</span>
                  {activeFiltersCount > 0 && (
                    <span className="active-count">({activeFiltersCount})</span>
                  )}
                </button>
              </div>
              {activeFiltersCount > 0 && (
                <button className="clear-all-btn" onClick={clearAllFilters}>
                  Clear All
                </button>
              )}
            </div>

            <div className={`filters-grid-simple ${showFilters ? "show" : ""}`}>
              {/* Gender Filter Button */}
              {/* {!name &&
                !searchParams.get("filter") &&
                genderCategories.length > 0 && (
                  <button
                    className={`filter-modal-btn ${
                      selectedGender !== "all" ? "has-value" : ""
                    }`}
                    onClick={() => setShowGenderModal(true)}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx="12" cy="7" r="4" />
                    </svg>
                    <span>
                      {selectedGender === "all"
                        ? "Gender"
                        : genderCategories.find((g) => g.id === selectedGender)
                            ?.name || "Gender"}
                    </span>
                    {selectedGender !== "all" && (
                      <span className="filter-badge">1</span>
                    )}
                  </button>
                )} */}

              {/* Category Filter Button - Only show if not filtering by URL param */}
              {!name && !searchParams.get("filter") && (
                <button
                  className={`filter-modal-btn ${
                    selectedCategory !== "all" ? "has-value" : ""
                  }`}
                  onClick={() => setShowCategoryModal(true)}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                  </svg>
                  <span>
                    {selectedCategory === "all"
                      ? "Category"
                      : filteredCategories.find(
                          (c) => c.id === selectedCategory
                        )?.name || "Category"}
                  </span>
                  {selectedCategory !== "all" && (
                    <span className="filter-badge">1</span>
                  )}
                </button>
              )}

              {/* Size Filter Button */}
              <button
                className={`filter-modal-btn ${
                  selectedSize !== "all" ? "has-value" : ""
                }`}
                onClick={() => setShowSizeModal(true)}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <polyline points="21 8 21 21 3 21 3 8" />
                  <rect x="1" y="3" width="22" height="5" />
                  <line x1="10" y1="12" x2="14" y2="12" />
                </svg>
                <span>
                  {selectedSize === "all"
                    ? "Size"
                    : sizes.find((s) => s.value === selectedSize)?.label ||
                      selectedSize}
                </span>
                {selectedSize !== "all" && (
                  <span className="filter-badge">1</span>
                )}
              </button>
            </div>

            {/* Active Filters Tags */}
            {activeFiltersCount > 0 && (
              <div className="active-filters-tags">
                {/* {selectedGender !== "all" && (
                  <span className="filter-tag">
                    {genderCategories.find((g) => g.id === selectedGender)?.name}
                    <button onClick={() => setSelectedGender("all")}>
                      ×
                    </button>
                  </span>
                )} */}
                {selectedCategory !== "all" && !name && (
                  <span className="filter-tag">
                    {
                      filteredCategories.find((c) => c.id === selectedCategory)
                        ?.name
                    }
                    <button onClick={() => setSelectedCategory("all")}>
                      ×
                    </button>
                  </span>
                )}
                {selectedSize !== "all" && (
                  <span className="filter-tag">
                    Size:{" "}
                    {sizes.find((s) => s.value === selectedSize)?.label ||
                      selectedSize}
                    <button onClick={() => setSelectedSize("all")}>×</button>
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Results Count */}
          <div className="results-info">
            <p>
              {filteredProducts.length}{" "}
              {filteredProducts.length === 1 ? "Product" : "Products"} Found
            </p>
          </div>

          {/* Loading State */}
          {loading ? (
            <div className="loading-state-new">
              <div className="spinner-new"></div>
              <p>Loading products...</p>
            </div>
          ) : (
            <>
              {/* Products Grid */}
              {filteredProducts.length > 0 ? (
                <div className="products-grid-clean">
                  {filteredProducts.map((product) => (
                    <ProductCardNew
                      key={product._id}
                      product={product}
                      onProductClick={onProductClick}
                    />
                  ))}
                </div>
              ) : (
                <div className="no-products-found">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                  <h3>No products found</h3>
                  <p>
                    Try adjusting your filters to find what you're looking for
                  </p>
                  {activeFiltersCount > 0 && (
                    <button
                      className="reset-filters-btn"
                      onClick={clearAllFilters}
                    >
                      Reset All Filters
                    </button>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {/* Gender Modal */}
      {showGenderModal && (
        <div
          className="filter-modal-overlay"
          onClick={() => setShowGenderModal(false)}
        >
          <div className="filter-modal" onClick={(e) => e.stopPropagation()}>
            <div className="filter-modal-header">
              <h3>Select Gender</h3>
              <button
                className="filter-modal-close"
                onClick={() => setShowGenderModal(false)}
              >
                ×
              </button>
            </div>
            <div className="filter-modal-content">
              <button
                className={`filter-modal-item ${
                  selectedGender === "all" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedGender("all");
                  setSelectedCategory("all");
                  setShowGenderModal(false);
                }}
              >
                <span>All Genders</span>
                {selectedGender === "all" && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
              {genderCategories.map((gender) => (
                <button
                  key={gender.id}
                  className={`filter-modal-item ${
                    selectedGender === gender.id ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedGender(gender.id);
                    setSelectedCategory("all");
                    setShowGenderModal(false);
                  }}
                >
                  <span>{gender.name}</span>
                  {selectedGender === gender.id && (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Category Modal */}
      {showCategoryModal && (
        <div
          className="filter-modal-overlay"
          onClick={() => setShowCategoryModal(false)}
        >
          <div className="filter-modal" onClick={(e) => e.stopPropagation()}>
            <div className="filter-modal-header">
              <h3>Select Category</h3>
              <button
                className="filter-modal-close"
                onClick={() => setShowCategoryModal(false)}
              >
                ×
              </button>
            </div>
            <div className="filter-modal-content">
              <button
                className={`filter-modal-item ${
                  selectedCategory === "all" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedCategory("all");
                  setShowCategoryModal(false);
                }}
              >
                <span>All Categories</span>
                {selectedCategory === "all" && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
              {filteredCategories.map((cat) => (
                <button
                  key={cat.id}
                  className={`filter-modal-item ${
                    selectedCategory === cat.id ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedCategory(cat.id);
                    setShowCategoryModal(false);
                  }}
                >
                  <span>{cat.name}</span>
                  {selectedCategory === cat.id && (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Size Modal */}
      {showSizeModal && (
        <div
          className="filter-modal-overlay"
          onClick={() => setShowSizeModal(false)}
        >
          <div className="filter-modal" onClick={(e) => e.stopPropagation()}>
            <div className="filter-modal-header">
              <h3>Select Size</h3>
              <button
                className="filter-modal-close"
                onClick={() => setShowSizeModal(false)}
              >
                ×
              </button>
            </div>
            <div className="filter-modal-content">
              <button
                className={`filter-modal-item ${
                  selectedSize === "all" ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedSize("all");
                  setShowSizeModal(false);
                }}
              >
                <span>All Sizes</span>
                {selectedSize === "all" && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </button>
              {sizes.map((size) => (
                <button
                  key={size._id}
                  className={`filter-modal-item ${
                    selectedSize === size.value ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedSize(size.value);
                    setShowSizeModal(false);
                  }}
                >
                  <span>{size.label}</span>
                  {selectedSize === size.value && (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductsPage;
